const SDK_VERSION = '7.92.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
